import React from 'react';

const VolumeControl = ({ 
  volume, 
  audioEnabled, 
  onVolumeChange 
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {!audioEnabled && volume > 0 && (
        <span style={{ 
          fontSize: '11px', 
          color: '#ff9999',
          marginLeft: '5px'
        }}>
          (Move slider to enable sound)
        </span>
      )}
      <span style={{ fontSize: '14px' }}>🔊</span>
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={onVolumeChange}
        style={{
          width: '80px',
          cursor: 'pointer'
        }}
      />
      <span style={{ fontSize: '12px', minWidth: '35px', color: '#888' }}>
        {Math.round(volume * 100)}%
      </span>
    </div>
  );
};

export default VolumeControl;